import { ERRORS_STRUCT, DEFAULT_ERROR } from './errors';
import SERVER_ERRORS from './server_errors';

export default {
  ERRORS: ERRORS_STRUCT,
  SERVER_ERRORS,
  DEFAULT_ERROR
}